import { defaultDictionaryValueMissing } from '../repository';

export type SearchKey = 'EnterKeyword' | 'ErrorOccurred' | 'FoundNumberOfResultsFrom' | 'Search' | 'RequiredField';

export const getDefaultSearchValue = (key: SearchKey): string => {
	switch (key) {
		case 'EnterKeyword':
			return '[Enter keyword]';
		case 'ErrorOccurred':
			return '[An error occurred. Please try again]';
		case 'FoundNumberOfResultsFrom':
			return '[Found ${numberOfResults} results for]';
		case 'Search':
			return '[Search]';
		case 'RequiredField':
			return '[Required field]';
		default:
			return `${defaultDictionaryValueMissing}:${key}`;
	}
};
